export default __webpack_public_path__ + "static/Narul-885d69fae3a41c514afe1322fb20c6435a06690f676f70edb9c13ccdbec9088c.svg";